<template>
    <section>
        <b-field>
            <b-input type="textarea"
                     :placeholder="__('strings.product.type_or_paste_sku_here')"
                     v-model="skuFilterValue"
                     @blur="handleIdsTextAreaChange"
            ></b-input>
        </b-field>

        <b-field class="mt-5 has-text-right">
            <p class="control">
                <b-button class="mr-3"
                          @click="removeFilters"
                >
                    {{ __('strings.product.reset_skus') }}
                </b-button>
                <b-button class="is-primary"
                          @click="handleSearchSubmit"
                >
                    {{ __('strings.product.search') }}
                </b-button>
            </p>
        </b-field>

    </section>
</template>

<script>
export default {
    props: {
        filters: {
            required: true,
            type: Object
        }
    },
    data() {
        return {
            skuFilterValue: '',
            currentFilters: undefined
        }
    },
    beforeMount() {
        this.skuFilterValue = '';
        this.currentFilters = this.filters;
    },
    methods: {
        parseSkuValue(value) {
            const ids = value.match(/[0-9]{8,}/g);

            return [...new Set(ids)];
        },
        handleIdsTextAreaChange(value) {
            this.currentFilters.sku = this.parseSkuValue(this.skuFilterValue);
            this.skuFilterValue = this.currentFilters.sku.join(', ');
        },
        handleSearchSubmit() {
            if (this.currentFilters.sku.length > 0) {
                this.currentFilters = {
                    ...this.currentFilters,
                    retailers: [],
                    in_stock: [],
                    brand_id: [],
                    gender_id: [],
                    category_id: [],
                    season_id: []
                }
            }

            this.$emit('handleProductSearch', this.currentFilters);
        },
        removeFilters() {
            this.currentFilters = {
                ...this.currentFilters,
                sku: [],
            };
            this.skuFilterValue = '';
            this.$emit('handleProductSearch', this.currentFilters);
        }
    }
}
</script>
